import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { createTheme, styled } from '@mui/material/styles';
import { PROMETHEAN_BLUE, PROMETHEAN_TEXT } from '../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_BODY } from '../styles/typography/typography';
import { prometheanFont } from '../styles/font/font';
export var ROOT_PREFIX = 'EmbersLabeledBox';
export var LABEL_FOCUS_VISIBLE_CLASS = 'EmbersLabeledBox-focusVisible';
var MuiFormControlLabel = {
  styleOverrides: {
    root: _defineProperty(_defineProperty(_defineProperty({
      fontFamily: prometheanFont,
      alignItems: 'baseline',
      marginRight: 0,
      marginLeft: -5,
      '.MuiTypography-root': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_BODY), {}, {
        alignSelf: 'flex-start',
        paddingTop: 8,
        paddingBottom: 8,
        textAlign: 'left',
        '&.Mui-disabled': {
          color: PROMETHEAN_TEXT
        }
      })
    }, '&.' + LABEL_FOCUS_VISIBLE_CLASS, {
      position: 'relative',
      '::before': {
        content: '" "',
        position: 'absolute',
        display: 'block',
        top: 7,
        right: 0,
        bottom: 7,
        left: 7,
        outline: '2px solid ' + PROMETHEAN_BLUE
      }
    }), "&.".concat(ROOT_PREFIX, "-disabled"), {
      pointerEvents: 'none'
    }), ':not(&.' + LABEL_FOCUS_VISIBLE_CLASS + ')', {
      outline: 'none'
    }),
    labelPlacementStart: {
      marginLeft: 0
    }
  }
};
export var StyledUnclickableLabeledBox = styled('label')(_defineProperty(_defineProperty(_defineProperty({}, "&.".concat(ROOT_PREFIX), _objectSpread(_objectSpread(_objectSpread({}, MuiFormControlLabel.styleOverrides.root), PROMETHEAN_TYPOGRAPHY_BODY), {}, {
  display: 'inline-flex',
  verticalAlign: 'middle',
  tapHighlightColor: 'transparent',
  marginRight: 0,
  marginLeft: -5
})), "&.".concat(ROOT_PREFIX, "-start"), {
  flexDirection: 'row-reverse',
  justifyContent: 'left',
  marginLeft: 0
}), "&.".concat(ROOT_PREFIX, "-disabled"), {
  pointerEvents: 'none'
}));
export var createLabeledBoxTheme = function createLabeledBoxTheme(theme) {
  var _theme$components;
  return createTheme(_objectSpread(_objectSpread({}, theme || {}), {}, {
    components: _objectSpread(_objectSpread({}, (theme === null || theme === void 0 ? void 0 : theme.components) || {}), {}, {
      MuiFormControlLabel: _objectSpread(_objectSpread({}, _typeof((_theme$components = theme.components) === null || _theme$components === void 0 || (_theme$components = _theme$components.MuiFormControlLabel) === null || _theme$components === void 0 || (_theme$components = _theme$components.styleOverrides) === null || _theme$components === void 0 ? void 0 : _theme$components.root) === 'object' ? theme.components.MuiFormControlLabel.styleOverrides.root : {}), MuiFormControlLabel)
    })
  }));
};